import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visto-de-execucao',
  templateUrl: './visto-de-execucao.component.html',
  styleUrls: ['./visto-de-execucao.component.scss']
})
export class VistoDeExecucaoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
